import { render, staticRenderFns } from "./TsRatings.vue?vue&type=template&id=185f2a2a&"
import script from "./TsRatings.vue?vue&type=script&lang=js&"
export * from "./TsRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/felixries/Development/Plentymarkets/PlentyDevTool-Sync/10204/113/EngelTheme5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185f2a2a')) {
      api.createRecord('185f2a2a', component.options)
    } else {
      api.reload('185f2a2a', component.options)
    }
    module.hot.accept("./TsRatings.vue?vue&type=template&id=185f2a2a&", function () {
      api.rerender('185f2a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/custom/TsRatings.vue"
export default component.exports